import React from 'react';
import email from '../../components/email.json';

export default function OptinAboveBox() {
  return (
    <main>
      <h1>{email.optout.landing.ui.body.section1.voltageTitle.eng}</h1>
      <h2>{email.optin.landing.ui.body.section1.title2.eng}</h2>
      <hr />
      <h3 className='whyKeep'>
        {email.optin.landing.ui.body.section1.title.eng}
      </h3>
      <p>{email.optin.landing.ui.body.section1.privacy.eng}</p>
      <p>{email.optin.landing.ui.body.section1.voltage.eng}</p>
      <ul className='registerMyComputerUl'>
        <li>{email.optin.landing.ui.body.section1.cardNumber.eng}</li>
        <li>{email.optin.landing.ui.body.section1.securityCode.eng}</li>
      </ul>
    </main>
  );
}
